import rest from 'services/http/rest';
import ResponseError from 'services/http/rest/response-error';
import Response from 'services/http/rest/response';

rest
  .registerEndpoint({
    name: 'users',
    url: `${process.env.REACT_APP_BASE_URL}/v1/users`,
  })
  .registerResources(
    { name: 'login', path: '/login' },
    { name: 'signUp', path: '/sign-up' },
    { name: 'forgotPassword', path: '/forgot-password' },
  );

rest
  .registerEndpoint({
    name: 'admin',
    url: `${process.env.REACT_APP_BASE_URL}/v1/admin`,
  })
  .registerResources(
    { name: 'login', path: '/login' },
    // { name: 'checkIfCodeIsUsed', path: '/check-if-code-is-used' },
    // { name: 'markCodeAsUsed', path: '/mark-code-as-used' },
  );

interface IUserApi {
  login(email: string, password: string): Promise<Response | ResponseError>;
  adminLogin(
    email: string,
    password: string,
  ): Promise<Response | ResponseError>;
  // checkIfCodeIsUsed(code: string): Promise<Response | ResponseError>;
  // markCodeAsUsed(
  //   code: string,
  //   email: string,
  // ): Promise<Response | ResponseError>;
  register(dto: RegisterDTO): Promise<Response | ResponseError>;
  forgotPassword(email: string): Promise<Response | ResponseError>;
}

interface RegisterDTO {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
}

export function useUserApi(): IUserApi {
  return {
    adminLogin(
      email: string,
      password: string,
    ): Promise<Response | ResponseError> {
      return rest
        .getResource('admin.login')
        .post({ body: { email, password } });
    },
    login(email: string, password: string): Promise<Response | ResponseError> {
      return rest
        .getResource('users.login')
        .post({ body: { email, password } });
    },
    register(dto: RegisterDTO): Promise<Response | ResponseError> {
      return rest.getResource('users.signUp').post({ body: dto });
    },
    forgotPassword(email: string): Promise<Response | ResponseError> {
      return rest.getResource('users.forgotPassword').post({ body: { email } });
    },
    // markCodeAsUsed(
    //   code: string,
    //   email: string,
    // ): Promise<Response | ResponseError> {
    //   return rest
    //     .getResource('admin.markCodeAsUsed')
    //     .post({ body: { email, code } });
    // },
    // checkIfCodeIsUsed(code: string): Promise<Response | ResponseError> {
    //   return rest
    //     .getResource('admin.checkIfCodeIsUsed')
    //     .setQuery({ code })
    //     .get();
    // },
  };
}
